import { render, staticRenderFns } from "./ResourceRecords.vue?vue&type=template&id=7af5c18f&scoped=true&"
import script from "./ResourceRecords.vue?vue&type=script&lang=js&"
export * from "./ResourceRecords.vue?vue&type=script&lang=js&"
import style0 from "./ResourceRecords.vue?vue&type=style&index=0&id=7af5c18f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af5c18f",
  null
  
)

export default component.exports